import {adminClient} from 'better-auth/client/plugins';
import {createAuthClient} from 'better-auth/react';

const resolveBaseURL = (): string => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/v1/auth`;
  }

  return 'http://localhost:3000/v1/auth';
};

/**
 * Admin plugin is registered so session includes role/ban fields and admin
 * client APIs are available. Feature-level access control is enforced on the
 * server; pass shared `ac`/`roles` here when building admin UI permission checks.
 */
export const authClient = createAuthClient({
  baseURL: resolveBaseURL(),
  plugins: [adminClient()],
});

export type AuthClient = typeof authClient;
